import React, { Component } from 'react';
import { isEmpty } from '../../Common/Common';
import Switch from '../../Part_Sample/Switch';
import Select from '../../Part_Sample/Select';
import Top_Bar from '../../Part_Sample/Top_Bar';

export default class Add_Edit_Input_Condition extends Component {
	constructor(props) {
		super(props);

		this.condition_detail = {};
		this.program = JSON.parse(JSON.stringify(this.props.param.program));
		this.condition_index = 0;
		let selected_point_id = '';

		if (!isEmpty(this.props.param.condition_detail)) {
			// From Condition Detail
			this.condition_index = this.props.param.condition_index;
			this.condition_detail = JSON.parse(JSON.stringify(this.props.param.condition_detail));
			selected_point_id = this.condition_detail.mp;
		} else if (this.props.param.condition_index != null) {
			// Edit condition
			this.condition_index = this.props.param.condition_index;
			this.condition_detail = JSON.parse(JSON.stringify(this.props.param.program.condition[this.condition_index]));
			selected_point_id = this.condition_detail.mp;
		} else if (this.program.condition == null) {
			// Add new condition
			this.program.condition = [];
		} else {
			// Add new condition with existing conditions
			this.condition_index = this.program.condition.length;
		}

		this.state = {
			selected_point_id: selected_point_id,
		}
	}

	handlePrevious = () => {
		this.props.content_handler('Edit_Interlock_Input', this.props.param);
	}

	handleChangeMP = (selected_point_id) => {
		this.setState({
			selected_point_id: selected_point_id,
		})
	}

	handleConditionDetail = (type) => {
		if (this.condition_detail.type != type || this.condition_detail.mp != this.state.selected_point_id) {
			// Edit condition detail
			this.condition_detail.type = type;

			switch (type) {
				case 'stat':
					let point_type = window.app.state.point_list[this.state.selected_point_id].type;

					if (point_type == 'Lock') {
						this.condition_detail.value = { 'fix': 'close' };
					} else if (point_type == 'Selection') {
						let selection = window.app.state.point_list[this.state.selected_point_id].selection;

						let tempValue = Object.keys(selection)[0];

						if(tempValue == 'Inactive') tempValue = Object.keys(selection)[1];

						this.condition_detail.value = {'fix': tempValue};
					} else {
						this.condition_detail.value = { 'fix': 'off' };
					}

					this.condition_detail.condition = '=';
					break;
				case 'error':
				case 'alert':
					this.condition_detail.value = { 'fix': 'true' };
					this.condition_detail.condition = '=';
					break;
				case 'rt':
					this.condition_detail.value = { 'fix': 16 };
					this.condition_detail.condition = '>';
					break;
				case 'mode':
					this.condition_detail.value = { 'fix': 'C' };
					this.condition_detail.condition = '=';
					break;
				case 'value':
					this.condition_detail.value = { 'fix': 0 };
					this.condition_detail.condition = '>';
					break;
				default:
					this.condition_detail.value = {};
					this.condition_detail.condition = null;
			}
		}

		this.condition_detail.mp = this.state.selected_point_id;

		let param = this.props.param;
		param.condition_detail = this.condition_detail;
		param.condition_index = this.condition_index;
		if (isEmpty(this.program.condition[this.condition_index])) this.program.condition[this.condition_index] = {};
		param.program = this.program;

		this.props.content_handler('Add_Edit_Condition_Detail', param);
	}

	handleDelete = () => {
		this.program.condition.splice(this.props.param.condition_index, 1);
		let param = this.props.param;
		param.program = this.program;
		this.props.content_handler('Edit_Interlock_Input', param);
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let button_style = {
			cursor: 'pointer',
			background: 'white',
			width: this.props.width - 40,
			textAlign: 'left',
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 15,
			height: 50,
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)'
		}

		// Set point type if selected point id is not empty
		let point_type = "";
		if (this.state.selected_point_id != "") {
			point_type = window.app.state.point_list[this.state.selected_point_id].type;
		}

		const mp_list = [];

		for (let point_id in window.app.state.point_list) {
			let point_info = window.app.state.point_list[point_id];

			if (point_info.type != 'Meter' && point_info.type != 'SMeter' && point_info.type != 'Shutter') { //Tommy - 24/03/2021 - Only add in operation-able mangement points and not a shutter
				if (point_type === "") { // Set command and selected point id with the first element in the mp_list
					point_type = point_info.type;
					this.setState({ selected_point_id: point_id })
				}
				mp_list.push(<option value={point_id}>{point_info.name}</option>)
			}
		}

		let stat_text;
		switch (point_type) {
			case 'Occupied':
			case 'Selection':
				stat_text = <span>{this.props.receiver.getString('status')}</span>
				break;
			case 'Lock':
				stat_text = <span>{this.props.receiver.getString('op')}</span>
				break;
			default:
				stat_text = <span>{this.props.receiver.getString('stat')}</span>
				break;
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.param.condition_index == null ? this.props.receiver.getString('add_condition') : this.props.receiver.getString('edit_condition')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>

					<div id="scrollable-content" style={{ height: this.props.height - 140, paddingBottom: 60, overflow: 'auto' }}>
						<div id='mp_list' style={{ marginLeft: 10, textAlign: 'center' }}>
							<div style={{ width: this.props.width - 20 }}>
								<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('choose_device')}</span>
							</div>
							<div style={{ width: this.props.width - 20 }}>
								<Select
									style={{ verticalAlign: 'top', }}
									select_style={{ fontSize: 20, height: 35 }}
									options={mp_list}
									value={this.state.selected_point_id}
									onSelect={this.handleChangeMP}
								/>
							</div>
						</div>

						<div style={{ textAlign: 'left', marginTop: 20, marginLeft: 20 }}>
							<span>{this.props.receiver.getString('choose_cmd_type')}</span>
						</div>
						<div style={{ marginTop: 20, display: ['Ac', 'Dehumi', 'Status', 'Switch', 'LevelSw', 'SensorStat', 'Rgbw', 'Selection', 'Lock', 'Hrv', 'Occupied'].includes(point_type) ? 'block' : 'none' }}>
							<div id='stat' style={button_style} onClick={() => this.handleConditionDetail('stat')}>
								<div style={{ paddingTop: 15, marginLeft: 10 }}>
									{stat_text}
								</div>
							</div>
						</div>
						<div style={{ marginTop: 20, display: ['Ac', 'Dehumi', 'Status', 'Switch'].includes(point_type) ? 'block' : 'none' }}>
							<div id='error' style={button_style} onClick={() => this.handleConditionDetail('error')}>
								<div style={{ paddingTop: 15, marginLeft: 10 }}>
									<span>{this.props.receiver.getString('error')}</span>
								</div>
							</div>
						</div>
						<div style={{ marginTop: 20, display: ['Ac', 'Dehumi', 'Status', 'Switch'].includes(point_type) ? 'block' : 'none' }}>
							<div id='alert' style={button_style} onClick={() => this.handleConditionDetail('alert')}>
								<div style={{ paddingTop: 15, marginLeft: 10 }}>
									<span>{this.props.receiver.getString('alert')}</span>
								</div>
							</div>
						</div>
						<div style={{ marginTop: 20, display: ['Ac'].includes(point_type) ? 'block' : 'none' }}>
							<div id='rt' style={button_style} onClick={() => this.handleConditionDetail('rt')}>
								<div style={{ paddingTop: 15, marginLeft: 10 }}>
									<span>{this.props.receiver.getString('rt')}</span>
								</div>
							</div>
						</div>
						<div style={{ marginTop: 20, display: ['Ac'].includes(point_type) ? 'block' : 'none' }}>
							<div id='mode' style={button_style} onClick={() => this.handleConditionDetail('mode')}>
								<div style={{ paddingTop: 15, marginLeft: 10 }}>
									<span>{this.props.receiver.getString('mode')}</span>
								</div>
							</div>
						</div>
						<div style={{ marginTop: 20, display: ['Dehumi', 'Value', 'Level', 'LevelSw'].includes(point_type) ? 'block' : 'none' }}>
							<div id='value' style={button_style} onClick={() => this.handleConditionDetail('value')}>
								<div style={{ paddingTop: 15, marginLeft: 10 }}>
									<span>{this.props.receiver.getString('value')}</span>
								</div>
							</div>
						</div>

					</div>

				</div>
			</div>
		)
	}
}